module.exports = __webpack_public_path__ + "img/game-handle.778a16b7.svg";